import Joyride, { type CallBackProps } from 'react-joyride';
import { joyrideLocale, joyrideStyles } from './joyrideConfig';
import { policyDetailTourSteps } from './policyDetailTourSteps';
import { useCompanyPolicyTour } from './useCompanyPolicyTour';

const TOUR_STORAGE_KEY = 'hr-company-policy-detail-tour-completed';

type PolicyDetailTourProps = {
    run: boolean;
    onCallback: (data: {
        status?: string;
        type?: string;
        index?: number;
    }) => void;
};

export function PolicyDetailTour({ run, onCallback }: PolicyDetailTourProps) {
    const handleCallback = (data: CallBackProps) => {
        onCallback({ status: data.status, type: data.type, index: data.index });
    };

    return (
        <Joyride
            steps={policyDetailTourSteps}
            run={run}
            continuous
            showProgress
            showSkipButton
            callback={handleCallback}
            locale={joyrideLocale}
            styles={joyrideStyles}
            scrollToFirstStep
            scrollOffset={24}
            scrollDuration={300}
        />
    );
}

export function usePolicyDetailTour() {
    return useCompanyPolicyTour(TOUR_STORAGE_KEY);
}
